import { h, Component, createRef, Fragment } from "preact";
import { classNames } from "../helpers.js";
import tracking from "../tracking/tracking.js";

import DropdownList from "./DropdownList.jsx";

let idC = 0;

function stopPropagation(event) {
  event.stopPropagation();
}

export default class Dropdown extends Component {
  id = `dropdown-${++idC}`;
  triggerRef = createRef();
  instance = null;

  componentDidMount() {
    this.instance = M.Dropdown.init(this.triggerRef.current, {
      alignment: this.props.alignment || "right",
      constrainWidth: false,
      container: this.props.container,
      coverTrigger: false,
      closeOnClick: this.props.closeOnClick,
      onCloseEnd: this.props.onClose,
      onOpenStart: () => {
        this.props.trackingName &&
          tracking.track("dropdown.open", {
            name: this.props.trackingName,
          });
        this.props.onOpen && this.props.onOpen();
      },
      onOpenEnd: () => {
        this.instance.recalculateDimensions();
      },
    });
  }

  componentDidUpdate(oldProps) {
    if (
      this.instance.isOpen &&
      oldProps.items &&
      oldProps.items.length !== this.props.items.length
    ) {
      this.instance.recalculateDimensions();
    }
  }

  open() {
    this.instance && this.instance.open();
  }

  close() {
    this.instance && this.instance.close();
  }

  render() {
    const {
      alignment,
      children,
      dropdownClass,
      element,
      triggerClass,
      items,
      onClick,
      filter,
      title,
    } = this.props;

    function handleClick(value) {
      onClick && onClick(value);
    }

    return (
      <Fragment>
        <span
          class={classNames("dropdown__trigger", triggerClass)}
          data-target={this.id}
          ref={this.triggerRef}
          onClick={stopPropagation}
        >
          {children}
        </span>
        {element ? (
          <div
            class={classNames(
              dropdownClass,
              "filter__dropdown dropdown-content"
            )}
            id={this.id}
          >
            {element({ close: () => this.close() })}
          </div>
        ) : (
          <DropdownList
            class={dropdownClass}
            id={this.id}
            filter={filter}
            items={items.filter((x) => x)}
            onClick={handleClick}
            alignment={alignment}
            title={title}
            closer={() => this.close()}
          />
        )}
      </Fragment>
    );
  }
}
